module.exports = __webpack_public_path__ + "static/media/bell-ring.81913a02.svg";